(function () {
  var MIN_DISPLAY_MS = 500;
  var SAFETY_TIMEOUT_MS = 3000;

  var revealed = false;
  function reveal() {
    if (revealed) return;
    revealed = true;
    document.body.classList.add('pdp-page-loaded');
  }

  var minDurationMet = false;
  var imagesReady = false;
  var galleryFiltered = false;
  function tryReveal() {
    if (minDurationMet && imagesReady && galleryFiltered) reveal();
  }

  setTimeout(function () {
    minDurationMet = true;
    tryReveal();
  }, MIN_DISPLAY_MS);

  // Absolute safety net: never leave the real page hidden forever.
  setTimeout(reveal, SAFETY_TIMEOUT_MS);

  // custom.js runs filterGallery(getSelectedColor()) synchronously inside its
  // own DOMContentLoaded handler to hide gallery items that don't match the
  // selected color. The window "load" event is guaranteed by the browser to
  // fire strictly after DOMContentLoaded and everything it triggered, so
  // waiting for "load" guarantees that filtering has already finished —
  // without needing to touch custom.js itself.
  if (document.readyState === 'complete') {
    galleryFiltered = true;
  } else {
    window.addEventListener('load', function () {
      galleryFiltered = true;
      tryReveal();
    }, { once: true });
  }

  function checkImages() {
    var list = document.querySelector('.l4pr-container .l4pr');
    var images = list ? Array.prototype.slice.call(list.querySelectorAll('img')) : [];
    var pending = images.filter(function (img) {
      return !img.complete;
    });

    if (!pending.length) {
      imagesReady = true;
      tryReveal();
      return;
    }

    var remaining = pending.length;
    pending.forEach(function (img) {
      function settle() {
        remaining -= 1;
        if (remaining <= 0) {
          imagesReady = true;
          tryReveal();
        }
      }
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkImages);
  } else {
    checkImages();
  }
})();
